"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconScaleLight = function SvgIconScaleLight(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "scale light icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Scale Light Icon'), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M24.501 8.499c2.727 0 4.941 2.175 4.941 4.858a4.803 4.803 0 01-1.7 3.657 4.11 4.11 0 00-6.48 0 4.82 4.82 0 01-1.703-3.657c0-2.683 2.217-4.856 4.942-4.856v-.002zm-.84 21.865v8.782h2.353V30.57l2.592 2.548 1.664-1.634-5.536-5.443-5.538 5.442 1.664 1.635 2.803-2.755h-.002zm16.312 11.588a.834.834 0 01-.446.964.846.846 0 01-.373.084H9.848a.847.847 0 01-.83-.668.834.834 0 01.009-.38l5.548-20.486a.843.843 0 01.82-.617h5.265a3.994 3.994 0 01-.258-1.346 7.35 7.35 0 01-2.475-2.645 7.301 7.301 0 01-.904-3.501C17.02 9.299 20.375 6 24.5 6c4.127 0 7.483 3.3 7.483 7.357 0 2.567-1.348 4.828-3.384 6.146a3.92 3.92 0 01-.26 1.345h5.269c.381 0 .72.254.817.618l5.55 20.486h-.003z"
  }));
};

var _default = SvgIconScaleLight;
exports.default = _default;